import(/* webpackMode: "eager" */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\app\\jakarta\\sewa-mobil-jakarta\\page.tsx");
